import styles from "../assets/styles/componenets/teachers.module.css";
import { useState, useEffect, useRef } from "react";
import prof1 from "../assets/images/1.jpeg";
import prof2 from "../assets/images/2.jpeg";
import prof3 from "../assets/images/3.jpeg";
import prof4 from "../assets/images/4.jpeg";
import prof5 from "../assets/images/5.jpeg";
import prof6 from "../assets/images/6.jpeg";
import prof7 from "../assets/images/7.jpeg";
import prof8 from "../assets/images/8.jpeg";
import prof9 from "../assets/images/9.jpeg";

import { useTeacherContext } from "../context/teacherCVContext";

export default function Teachers() {
    const totalTeachers = 9;
    const slideWidth = 298;
    const totalTeachersDisplayed =
        window.innerWidth <= 655 ? 1 : window.innerWidth <= 984 ? 2 : 3;

    const maxSlide = totalTeachers - totalTeachersDisplayed;

    const [position, setPosition] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const intervalRef = useRef(null);

    const [isHeaderVisible, setIsHeaderVisible] = useState(false);
    const headerRef = useRef(null);

    const [isSliderVisible, setIsSliderVisible] = useState(false);
    const sliderRef = useRef(null);

    function slideLeft() {
        setIsPaused(true);
        setPosition((prev) =>
            prev === 0 ? maxSlide * slideWidth : prev - slideWidth
        );
        resetAutoSlide();
    }

    function slideRight() {
        setIsPaused(true);
        setPosition((prev) =>
            prev >= maxSlide * slideWidth ? 0 : prev + slideWidth
        );
        resetAutoSlide();
    }

    function resetAutoSlide() {
        clearInterval(intervalRef.current);
        setTimeout(() => {
            setIsPaused(false);
        }, 5000);
    }

    useEffect(() => {
        if (isPaused || !isSliderVisible) return;

        intervalRef.current = setInterval(() => {
            setPosition((prev) =>
                prev >= maxSlide * slideWidth ? 0 : prev + slideWidth
            );
        }, 2000);

        return () => clearInterval(intervalRef.current);
    }, [isPaused, maxSlide, isSliderVisible]);

    useEffect(() => {
        const headerObserver = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setIsHeaderVisible(true);
            },
            { threshold: 0.1 }
        );
        if (headerRef.current) headerObserver.observe(headerRef.current);

        const sliderObserver = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setIsSliderVisible(true);
            },
            { threshold: 0.2 }
        );
        if (sliderRef.current) sliderObserver.observe(sliderRef.current);
    }, []);

    return (
        <div className={styles.container} id="teachers">
            <div
                ref={headerRef}
                className={`${styles.header} ${
                    isHeaderVisible && styles.visible
                }`}
            >
                <h2>Դասախոսական կազմը</h2>
                <p>
                    Դասախոսական կազմը բաղկացած է իրավագիտության ոլորտի
                    հեղինակավոր մասնագետներից, ովքեր ամենօրյա աշխատանքով
                    նպաստում են իրավագիտության ոլորտի կայացմանն ու ապագա
                    իրավաբանների արդյունավետ կրթությանը: Իրենց բազմամյա փորձով և
                    բազմաբնույթ մասնագիտացումներով՝ ունկնդիրներին փոխանցում են
                    խորքային իրավական գիտելիքներ։
                </p>
            </div>
            <div
                ref={sliderRef}
                className={`${styles.sliderContainer} ${
                    isSliderVisible && styles.visible
                }`}
            >
                <div className={styles.teachers}>
                    <div
                        className={styles.teacherSlider}
                        style={{ left: `-${position}px` }}
                    >
                        <Teacher prof={prof1} name="Արև Հարությունյան" cv="1" />
                        <Teacher prof={prof2} name="Ելենա Ալեքսանյան" cv="2" />
                        <Teacher
                            prof={prof8}
                            name="Քրիստինե Ալեքսանյան"
                            cv="8"
                        />
                        <Teacher prof={prof5} name="Մերի Խաչատրյան" cv="5" />
                        <Teacher
                            prof={prof6}
                            name="Հովհաննես Հովհաննիսյան"
                            cv="6"
                        />
                        <Teacher prof={prof7} name="Ահարոն Ստեփանյան" cv="7" />

                        <Teacher
                            prof={prof9}
                            name="Արմեն Հարությունյան"
                            cv="9"
                        />

                        <Teacher prof={prof4} name="Մանե Խաչատրյան" cv="4" />

                        <Teacher prof={prof3} name="Եղեգնի Բաբայան" cv="3" />
                    </div>
                    <div className={styles.sliderBtnContainer}>
                        <button onClick={slideLeft}>
                            <i className="fa-solid fa-arrow-left"></i>
                        </button>
                        <button onClick={slideRight}>
                            <i className="fa-solid fa-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function Teacher({ prof, name, cv }) {
    const { setSelectedTeacher } = useTeacherContext();

    return (
        <div className={styles.teacher}>
            <img src={prof} alt={`Prof. ${name}`} />
            <div>
                <h2>{name}</h2>
                <button onClick={() => setSelectedTeacher(cv)}>
                    Դիտել ավելին
                </button>
            </div>
        </div>
    );
}
//
// <p>Constitutional Law Expert</p>
// <span>Specialist in constitutional law and civil rights.</span>
